import React, { useEffect, useState } from "react";
import { IoReload } from "react-icons/io5";
import { MdAdd } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { FieldProps, panelTypesDefault } from "../../../@types/panelTypes";
import { Search } from "../../../components/Search";
import { PanelAndDetailAndCreateHeader } from "../../../components/panel/PanelAndDetailAndCreateHeader";
import { PanelLayout } from "../../../components/panel/PanelLayout";
import { Pagination } from "../../../components/panel/table/Pagination";
import { TableContent } from "../../../components/panel/table/TableContent";
import { TableHeader } from "../../../components/panel/table/TableHeader";
import { Contact, useContacts } from "../../../hook/queries/useContact";
import { setQueryParams, useQueryParams } from "../../../hook/useQueryParams";

interface PanelColorsProps extends panelTypesDefault {}

const columns: FieldProps[] = [
  {
    name: "id",
    field: "Id",
    viewList: false,
  },
  {
    name: "title",
    field: "Titulo",
    viewList: true,
  },
  {
    name: "created_atFormatted",
    field: "Criação",
    viewList: true,
  },
];

const PanelContacts: React.FC<PanelColorsProps> = () => {
  const history = useHistory();
  const query = useQueryParams();

  const [page, setPage] = useState<number>(() => {
    const pageQuery = query.get("page");

    if (!isNaN(Number(pageQuery)) && Number(pageQuery) > 0)
      return Number(pageQuery);

    return 1;
  });
  const [search, setSearch] = useState(() => {
    const searchQuery = query.get("search");

    if (searchQuery && searchQuery.length > 0) {
      return String(searchQuery);
    }

    return "";
  });
  const { data, isLoading, isFetching, refetch } = useContacts(page, search);

  useEffect(() => {
    if (page > 0) {
      setQueryParams({
        data: {
          field: "page",
          value: String(page),
        },
        type: "set",
        history,
      });
    }

    if (search.length > 0) {
      setQueryParams({
        data: {
          field: "search",
          value: String(search),
        },
        type: "set",
        history,
      });
    } else {
      setQueryParams({
        data: {
          field: "search",
          value: String(search),
        },
        type: "delete",
        history,
      });
    }
  }, [page, history, search]);

  function handleNewColor() {
    history.push("/admin/criar/contatos");
  }

  return (
    <PanelLayout>
      <PanelAndDetailAndCreateHeader title="Lista de Contatos" />

      <Search
        handleSearch={(search) => {
          setPage(1);
          setSearch(search);
        }}
        currentSearch={search}
      />

      <TableHeader title="CONTATOS" isFetching={isFetching && !isLoading}>
        <button onClick={() => refetch()}>
          <IoReload size={19} />
          <span>RECARREGAR</span>
        </button>
        <button onClick={handleNewColor} type="button">
          <MdAdd size={22} /> <span> NOVA </span>
        </button>
      </TableHeader>

      <TableContent<Contact>
        data={data?.contacts}
        columns={columns.filter((f) => f.viewList)}
        isLoading={isLoading}
        onClickRow={(e) => history.push(`/admin/contatos/${e.id}`)}
      />
      <Pagination
        totalCountOfRegisters={data?.totalCount ?? 0}
        currentPage={page}
        onPageChange={setPage}
      />
    </PanelLayout>
  );
};

export default PanelContacts;
